import { useState, useEffect, Suspense } from "react";
import { AppRoutes, REACTIONS_TYPES, LOCAL_STORAGE } from "@shared/constants";
import { useUserProfile } from "@shared/hooks";
import { MainLayout } from "@widgets/layout";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { Loader } from "@widgets/Loader";
import {
  AuthError,
  EmptyProfile,
  ErrorPage,
  IntrodactionForm,
  Itroduction,
  Match,
  Profile,
  UserPage,
  getStartAppParams,
} from "@shared/utils";
import { UserRatingPage } from "@pages/UserRating";
import { ReactionsList } from "@shared/ui/ReactionsList";
import { ReactionsLayout } from "@widgets/ReactionsLayout";

export const RouterProvider = () => {
  const location = useLocation();
  const isAuthErrorPage = location.pathname.includes(AppRoutes.AUTH_ERROR);
  const hasRefreshToken = Boolean(
    localStorage.getItem(LOCAL_STORAGE.RefreshToken)
  );

  const shouldSkipProfile = isAuthErrorPage || !hasRefreshToken;

  const {
    isNewProfile,
    isLoading: isProfileLoading,
    unfilledFieldsMessage,
  } = useUserProfile({ skip: shouldSkipProfile });
  const [isRouterReady, setIsRouterReady] = useState(false);

  useEffect(() => {
    // Если пропускаем загрузку профиля, сразу готовы
    if (shouldSkipProfile || !isProfileLoading) {
      const timer = setTimeout(() => {
        setIsRouterReady(true);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [isProfileLoading, shouldSkipProfile]);

  const getInitialRoute = () => {
    if (isProfileLoading && !shouldSkipProfile) {
      return <Loader />;
    }

    const startAppParams = getStartAppParams();
    if (startAppParams?.userId) {
      return <Navigate to={`/users/${startAppParams.userId}`} replace />;
    }

    if (isNewProfile) {
      return <Itroduction />;
    }

    return <Navigate to={`/${AppRoutes.PROFILE}`} replace />;
  };

  // Не показываем Loader на странице authError
  if (!isRouterReady && isProfileLoading && !shouldSkipProfile) {
    return <Loader />;
  }

  return (
    <Routes>
      <Route
        path={AppRoutes.AUTH_ERROR}
        element={
          <Suspense fallback={<Loader />}>
            <AuthError />
          </Suspense>
        }
      />
      <Route
        path={AppRoutes.ERROR}
        element={
          <Suspense fallback={<Loader />}>
            <ErrorPage />
          </Suspense>
        }
      />
      <Route path={AppRoutes.ROOT} element={<MainLayout />}>
        <Route index element={getInitialRoute()} />

        <Route path={AppRoutes.REACTIONS} element={<ReactionsLayout />}>
          <Route
            path={AppRoutes.LIKES}
            element={
              <Suspense fallback={<Loader />}>
                <ReactionsList reactionsType={REACTIONS_TYPES.Likes} />
              </Suspense>
            }
          />
          <Route
            path={AppRoutes.MATHCES}
            element={
              <Suspense fallback={<Loader />}>
                <ReactionsList reactionsType={REACTIONS_TYPES.Matches} />
              </Suspense>
            }
          />
          <Route
            path={AppRoutes.USER_RATING}
            element={
              <Suspense fallback={<Loader />}>
                <UserRatingPage />
              </Suspense>
            }
          />
        </Route>

        <Route
          path={AppRoutes.MATCH}
          element={
            <Suspense fallback={<Loader />}>
              <Match />
            </Suspense>
          }
        />
        <Route
          path={AppRoutes.PROFILE}
          element={
            <Suspense fallback={<Loader />}>
              <Profile />
            </Suspense>
          }
        />
        <Route
          path={AppRoutes.EMPTY_PROFILE}
          element={
            <Suspense fallback={<Loader />}>
              <EmptyProfile unfilledFieldsMessage={unfilledFieldsMessage} />
            </Suspense>
          }
        />
        <Route
          path={AppRoutes.INTRO_FORM}
          element={
            <Suspense fallback={<Loader />}>
              <IntrodactionForm />
            </Suspense>
          }
        />

        <Route
          path={AppRoutes.USER}
          element={
            <Suspense fallback={<Loader />}>
              <UserPage />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
};
